import styled from 'styled-components';
import colors from '../../../../../../../../styles/colors';

const InfoSection = styled.section`
  padding: 18px;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const InfoRow = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: flex-start;
  gap: 15px;
`;

const InfoLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  width: fit-content;
  ${({ $marginTop }) => $marginTop && `margin-top: ${$marginTop}px;`}
`;

const InfoValue = styled.div`
  flex: 1;
  word-break: break-word;
  font-size: 14px;
`;

const PricingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 4px;
  margin-bottom: 12px;
  font-size: 14px;

  td:first-child {
    min-width: 50px;
  }
  
  td:nth-child(2) {
    width: 70px;
  }
`;

const PricingTh = styled.th`
  border-bottom: 2px solid #ddd;
  padding: 6px 8px;
  text-align: left;
  background: ${colors.base.alpha};
  font-weight: 600;
`;

const PricingTd = styled.td`
  border-bottom: 1px solid ${colors.shades.gamma13};
  padding: 6px 8px;
  color: #444;
`;

export {
  InfoSection,
  InfoRow,
  InfoLabel,
  InfoValue,
  PricingTable,
  PricingTh,
  PricingTd,
};
